import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout from "../../components/Layout";
import Loader from "react-loader-advanced";
import LoadingSpin from "react-loading-spin";
import config from "../../assets/config";
import BarChart from "../BarChart";
import LineChart from "../LineChart";
import DoughnutChart from "../DoughnutChart";
import { Nav, NavItem, NavLink, TabContent, TabPane, Container, Row, Col } from "reactstrap"



function Resource({ id, location }) {

    const { state } = location;
    const [item, setItem] = useState(state && state.dataset ? state.dataset : {});
    const [title, setTitle] = useState(true);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('1');

    useEffect(() => {
        if (state && state.dataset) {
            setLoading(false);
        } else {
            axios.get(`${process.env.REACT_APP_ROOT_URL}/metastore/schemas/distribution/items/${id}`).then((res) => {
                setTitle(res.data.data.title)
            })
            axios.get(`${process.env.REACT_APP_ROOT_URL}/datastore/sql/?query=[SELECT%20*%20FROM%20${id}][LIMIT%20100];&show-db-columns`)
                .then((res) => {
                    setItem(res.data);
                    setLoading(false);
                })
        }
    }, [id, state])


    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <Layout title="Datastore" headerClass='header header--small'>
            <div className={`dc-dataset-page ${config.container}`}>
                <Loader
                    backgroundStyle={{ backgroundColor: "#f9fafb" }}
                    foregroundStyle={{ backgroundColor: "#f9fafb" }}
                    show={loading}
                    message={
                        <LoadingSpin width={"3px"} primaryColor={"#007BBC"} />
                    }
                >
                    <p class="title title--black p-5">{title}</p>
                    <Container>
                        <Row>
                            <Col sm="12">
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={activeTab === '1' ? 'active' : ''}
                                            onClick={() => toggleTab('1')}
                                        >
                                            <h4>Barras</h4>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={activeTab === '2' ? 'active' : ''}
                                            onClick={() => toggleTab('2')}
                                        >
                                            <h4>Líneas</h4>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={activeTab === '3' ? 'active' : ''}
                                            onClick={() => toggleTab('3')}
                                        >
                                            <h4>Dona</h4>
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <h4 className="pt-5">Gráfica de Barras</h4>
                                        <div className="alert alert-primary m-5" role="alert">
                                            <h4 className="alert-heading"><b>¡Hola!</b></h4>
                                            <p className="paragraph-graph"><b>Para iniciar a graficar, por favor selecciona una serie.</b></p>
                                            <hr />
                                            <p className="mb-0 paragraph-graph"><b>Para una mejor interacción con la gráfica, puedes hacer uso del scroll del mouse o dar clic sobre la gráfica y arrastra el cursor para seleccionar el área sobre la que se desea hacer zoom.</b></p>
                                            <p className="mb-0 paragraph-graph"><b>De igual forma puedes hacer clic en el botón Reset Zoom para reestablecer la gráfica.</b></p>
                                        </div>
                                        <BarChart item={item} />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <h4 className="pt-5">Gráfica de Líneas</h4>
                                        <div className="alert alert-primary m-5" role="alert">
                                            <h4 className="alert-heading"><b>¡Hola!</b></h4>
                                            <p className="paragraph-graph"><b>Para iniciar a graficar, por favor selecciona una serie.</b></p>
                                            <hr />
                                            <p className="mb-0 paragraph-graph"><b>Para una mejor interacción con la gráfica, puedes hacer uso del scroll del mouse o dar clic sobre la gráfica y arrastra el cursor para seleccionar el área sobre la que se desea hacer zoom.</b></p>
                                            <p className="mb-0 paragraph-graph"><b>De igual forma puedes hacer clic en el botón Reset Zoom para reestablecer la gráfica.</b></p>
                                        </div>
                                        <LineChart item={item} />
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <h4 className="pt-5">Gráfica de Dona</h4>
                                        <div className="alert alert-primary m-5" role="alert">
                                            <h4 className="alert-heading"><b>¡Hola!</b></h4>
                                            <p className="paragraph-graph"><b>Para iniciar a graficar, por favor selecciona una serie.</b></p>
                                        </div>
                                        <DoughnutChart item={item} />
                                    </TabPane>
                                </TabContent>
                            </Col>
                        </Row>
                    </Container>
                </Loader>
            </div>
        </Layout>
    );



}

export default Resource